var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-modal',{attrs:{"visible":_vm.previewVisible,"footer":null,"width":"40%","get-container":_vm.getModalContainer},on:{"cancel":_vm.handleCancel}},[(_vm.images.length)?_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.images[0],"alt":"预览图片"}}):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }